module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/points/point_10-30b122bacfb8d7879829467dec1304be.svg";